import { useRetailerNotificationIndicator } from "../useRetailerNotificationIndicator";
import { NavigationActivityOverlay } from "./NavigationActivityOverlay";
import { NOTIFICATIONS } from "../../../constants/routes";
import { useNavigationOverlay } from "./NavigationOverlayContext.shared";
import { NotificationsNavigationContent } from "./NotificationsNavigationContent";

export const NotificationsNavigationOverlay = () => {
  const hasUnread = useRetailerNotificationIndicator();
  const { closeOverlay } = useNavigationOverlay();
  return (
    <NavigationActivityOverlay
      id="notifications"
      title="Notifications"
      icon="BELL_OUTLINE"
      href={NOTIFICATIONS}
      hasUnread={hasUnread}
    >
      <NotificationsNavigationContent
        onClose={() => closeOverlay("notifications")}
      />
    </NavigationActivityOverlay>
  );
};
